import localhost from "../../../apis/localhost";
import {
  selectSharepoint,
  selectSharepointAccessCheckOwner,
} from "../selectors";
import {
  beginAccessCheck,
  endAccessCheck,
  updateSiteAccess,
} from "../sharepointSlice";
import { ACCESS_BATCH_SIZE, SKIP_REDIRECT } from "./constants";
import { handledPolicyError } from "./policyErrors";
import {
  outcomesFor,
  pendingAccessIds,
  samePolicy,
  unknownOutcomes,
} from "./utils";

export const checkSiteAccess = () => async (dispatch, getState) => {
  const sharepoint = selectSharepoint(getState());
  if (!sharepoint.restricted || sharepoint.accessCheckPending) {
    return;
  }
  const revision = sharepoint.policyRevision;
  const requested = new Set();
  const nextBatch = (current) =>
    pendingAccessIds(current)
      .filter((id) => !requested.has(id))
      .slice(0, ACCESS_BATCH_SIZE);
  let batch = nextBatch(sharepoint);
  if (batch.length === 0) {
    return;
  }
  dispatch(beginAccessCheck());
  const owner = selectSharepointAccessCheckOwner(getState());
  const owns = (current) =>
    current.accessCheckOwner === owner && samePolicy(current, revision);
  try {
    while (batch.length > 0) {
      batch.forEach((id) => requested.add(id));
      const { data } = await localhost.post(
        "/sharepoint/sites/access",
        { policyRevision: revision, siteIds: batch },
        SKIP_REDIRECT
      );
      if (
        !owns(selectSharepoint(getState())) ||
        data?.policyRevision !== revision
      ) {
        return;
      }
      dispatch(updateSiteAccess(outcomesFor(batch, data.results)));
      batch = nextBatch(selectSharepoint(getState()));
    }
  } catch (error) {
    if (!owns(selectSharepoint(getState()))) {
      return;
    }
    if (!handledPolicyError(dispatch, error)) {
      dispatch(updateSiteAccess(unknownOutcomes(batch)));
    }
  } finally {
    if (owns(selectSharepoint(getState()))) {
      dispatch(endAccessCheck(owner));
      const latest = selectSharepoint(getState());
      if (samePolicy(latest, revision) && nextBatch(latest).length > 0) {
        dispatch(checkSiteAccess());
      }
    }
  }
};
